import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { Grouping } from '@classes/grouping/grouping';
import { GroupingService } from '@services/grouping.service';
import { GroupingLists } from '@classes/grouping/grouping-lists';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-grouping',
    templateUrl: './grouping.component.html',
    styleUrls: ['./grouping.component.scss']
})
export class GroupingComponent implements OnInit, OnDestroy {
    private groupsListSub: Subscription;
    private publicGroupsListSub: Subscription;
    private selectGroupSub: Subscription;

    groups: Grouping[];
    publicGroups: Grouping[];
    selectedGroup: Grouping;

    constructor(
        private compareSrv: GroupingService,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.getRouteData();
        this.initSubscriptions();
    }

    private getRouteData(): void {
        this.route.data
        .subscribe((data: { groups: GroupingLists }) => {
            this.groups = data.groups.groups;
            this.publicGroups = data.groups.publicGroups;
        });
    }

    private initSubscriptions(): void {
        this.groupsListSub = this.compareSrv.groupsListChanged
        .subscribe(groupsFromSrv => {
            this.groups = groupsFromSrv;
        });

        this.publicGroupsListSub = this.compareSrv.publicGroupsListChanged
        .subscribe(groupsFromSrv => {
            this.publicGroups = groupsFromSrv;
        });

        this.selectGroupSub = this.compareSrv.selectedGroupChanged
        .subscribe(selectedGroup => {
            this.selectedGroup = selectedGroup;
        });
    }

    ngOnDestroy(): void {
        if(this.groupsListSub) {
            this.groupsListSub.unsubscribe();
        }

        if(this.publicGroupsListSub) {
            this.publicGroupsListSub.unsubscribe();
        }

        if(this.selectGroupSub) {
            this.selectGroupSub.unsubscribe();
        }
    }
}
